module.exports = __webpack_public_path__ + "img/tiklanish-4.eb67fdc7.png";